module.exports = __webpack_public_path__ + "img/web_app_interface.b1c2f6c1.png";